import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { AccountsService } from '../../services/account.service';
import { SnackbarService } from '../../services/snackbar.service';
import { ChangePasswordDto, SingleResponseDto } from '@bugz-mono/shared-dtos';
import { UsersApiService } from '@bugz-mono/shared-services';


@Component({
  selector: 'app-manage-password-dialog',
  templateUrl: './manage-password-dialog.component.html',
  styleUrls: ['./manage-password-dialog.component.scss']
})
export class ManagePasswordDialogComponent implements OnInit  {
  changePasswordForm!: FormGroup;
  backColor?='';
  foreColor?='';

  response?='';

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private accountServie: AccountsService,
    private usersService: UsersApiService,
    private readonly snackbarService: SnackbarService,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ManagePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.changePasswordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(4)]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordsMatch });
  }
  ngOnInit(): void {
    this.backColor = this.accountServie.getBackColor();
    this.foreColor = this.accountServie.getForeColor();
    console.log('data mode: ', this.data.mode);
    if(this.data.mode==='reset'){
      const password=this.commonService.generateRandomPassword(6)
      this.changePasswordForm.patchValue({
        newPassword: password,
        confirmPassword:password
      });
    }
  }
  passwordsMatch(group: FormGroup) {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { notMatching: true };
  }

  onSubmit() {
    if (!this.changePasswordForm.valid) {
          return;
        }
        const updatePasswordDto : ChangePasswordDto = {
          id: this.data.customer?.id,
          newPassword: this.changePasswordForm.value.newPassword,
          currentPassword: this.changePasswordForm.value.currentPassword,
        };
        this.usersService.changePassword(updatePasswordDto).subscribe(
        {
          next: (res : SingleResponseDto<any>) => {
            if (!res.success) {
              this.snackbarService.showMessage("error",res.message);
              return;
            }
            this.response= res.message;
            this.snackbarService.showMessage("success",res.message);
            // this.cdr.detectChanges();
            this.dialogRef.close(true);
          },
          error: (err) => {
            console.log('error uploading files',err);
            this.snackbarService.showMessage("error",'Unable to update password.', );
          },
          complete: () => {
            // this.isLoading=false;
          }
        });
        
    // if (this.changePasswordForm.valid) {
    //   const { currentPassword, newPassword } = this.changePasswordForm.value;
    //   this.dialogRef.close({ currentPassword, newPassword });
    // }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
